import { Component,ViewChild, inject,ElementRef } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { COMMA, ENTER,TAB } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { Options,LabelType  } from '@angular-slider/ngx-slider';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { async } from 'rxjs';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: "app-video-upload",
  templateUrl: "./video-upload.component.html",
  styleUrls: ["./video-upload.component.scss"],
})

export class VideoUploadComponent {

  value: number = 1;
  options: Options = {
    step: 750,
    showTicksValues: false,    
    showTicks: true,
    stepsArray: [
      {value: 0, legend: 'Low'},
      {value: 1250, legend: 'Medium'},
      {value: 2500, legend: 'High'}
    ],
  };
  public datadetail: any = [];
  public dropdownSettings: IDropdownSettings;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA,TAB];
  public currentUrl:any=this.router.url;
  addOnBlur = true;  
  public post_type:any=1;
  public post_ctype:any=1;
  fruits: any = [];
  public chceckall:boolean=false;
  public EquipmentArray:any = [{id: 1,equipment: '',sets: '',reps:''}];
  announcer = inject(LiveAnnouncer);
  public loading:boolean = false;
  public submitted:boolean = false;
  public videoUrl:any='';
  public mesage:any='';
  public otherSelection:any='';
  public m_otherSelection:any='';
  public ms_otherSelection:any='';
  public d_otherSelection:any='';
  public s_otherSelection:any='';
  public c_otherSelection:any='';
  public stepArray:any=[{id:1,text:'',textdisabled:true, checkdisabled:false}];
  public freeshowhide:any=false;
  public vst:any='';
  public vnu:any='';
  public ist:any='';
  public inu:any='';
  public dst:any='';
  public dnu:any='';
  public filesName:any='';
  public subprimarySelected:any=[];
  public subprimaryname:any='';
  public TypeSelected:any=[];
  public Typename:any='';
  public cycleChcek:any=false;
  public logGender:any='';
  public logGendername:any='';

  
  public sliderArray:any=[{id:1,name:'Balance',text:'balance', value:1},
  {id:2,name:'Flexibility',text:'flexibility', value:1},
  {id:3,name:'Focus',text:'focus', value:1},
  {id:4,name:'Strength',text:'strength', value:1},
  {id:5,name:'Endurance',text:'endurance', value:1},];

  public sliderArray1:any=[{id:1,name:'Balance',text:'balance', value:1},
  {id:2,name:'Flexibility',text:'flexibility', value:1},
  {id:3,name:'Focus',text:'focus', value:1},
  {id:4,name:'Strength',text:'strength', value:1},
  {id:5,name:'Endurance',text:'endurance', value:1},];

  public sliderArray2:any=[{id:1,name:'Balance',text:'balance', value:1},
  {id:2,name:'Flexibility',text:'flexibility', value:1},
  {id:3,name:'Focus',text:'focus', value:1},
  {id:4,name:'Strength',text:'strength', value:1},
  {id:5,name:'Endurance',text:'endurance', value:1},];

  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = localStorage.getItem('grw_upload_images');;
  public message: any;
  visible = true;
  selectable = true;
  removable = true;
  dd :boolean = false;
  public allmasterData:any={};
  public GenderList:any=[];
  public CycleList:any=[];
  public LevelLIst:any=[];
  public TypeList:any=[];
  public suitabilityList:any=[];
  public medicalList:any=[];
  public areasList:any=[];
  public contentpillerList:any=[];
  public albumList:any=[];
  public cookingList:any=[];
  public dietList:any=[];
  public dimendionList:any=[];
  public preprationList:any=[];
  public primaryList:any=[];
  public subprimaryList:any=[];
  public taglist:any=[];
  public demographicList:any=[];
  title = "CodeSandbox";
  tags:any = [];
  placeholder = "Enter tags";
  limit:any= 15;
  public selectedVidoe: any = "";
  public videoName: any = "";
  public videoSize: any = "";

  public standardview:boolean = true;
  public nutritionView:boolean = false;

  public detailView:boolean = true;
  public prefrenceView:boolean = false;
  public requermentView:boolean = false;  

  public videodview:boolean = true;
  public imageView:boolean = false;
  public docView:boolean = false;
  public companySelected:any='';
  public freechcek:boolean=false;
  public tt:boolean= false;  
  public post_id:any='';

  displayTags(updateTags:any) {
    // console.log(updateTags);
  }


  StandardDetailFormGroup= new FormGroup({
    description:new FormControl('',Validators.compose([Validators.required ,Validators.maxLength(140),Validators.minLength(10)])),
    level:new FormControl('',Validators.compose([Validators.required])),
    types:new FormControl('',Validators.compose([Validators.required])),
    others:new FormControl(''),
    hours:new FormControl(0),
    minute:new FormControl(0),
    second:new FormControl(0),  
    contentpiller:new FormControl('',Validators.compose([Validators.required])),
    demographic:new FormControl('',Validators.compose([Validators.required])), 
    gender:new FormControl('',Validators.compose([Validators.required])),
    cycle:new FormControl(''),
    balance:new FormControl(''),
    flexibility:new FormControl(''),
    focus:new FormControl(''),
    strength:new FormControl(''),
    endurance:new FormControl(''), 
    m_others:new FormControl(''),
    ms_others:new FormControl(''),
  });


  NutritionDetailFormGroup= new FormGroup({ 
    description:new FormControl('',Validators.compose([Validators.required ,Validators.maxLength(140),Validators.minLength(10)])),
    totalTime:new FormControl(0,Validators.compose([Validators.required ,Validators.max(999),Validators.min(0)])),
    prepTime:new FormControl(0,Validators.compose([Validators.required ,Validators.max(999),Validators.min(0)])),
    balance:new FormControl('',Validators.compose([Validators.required ,Validators.max(9999),Validators.min(0)])),
    cookingTime:new FormControl(0,Validators.compose([Validators.required ,Validators.max(999),Validators.min(0)])),
    sprimary:new FormControl('',Validators.compose([Validators.required])),   
    s_others:new FormControl(''),
    d_others:new FormControl(''), 
    primarycategory: new FormControl(''),
    keywords:new FormControl('',Validators.compose([Validators.required])),
    demographic:new FormControl('',Validators.compose([Validators.required])),
    diet:new FormControl('',Validators.compose([Validators.required]))

  });

  get sf() { return this.StandardDetailFormGroup.controls; }

  get nf() { return this.NutritionDetailFormGroup.controls; } 


   constructor(private el: ElementRef,public router: Router, public service: GlobalService) { 
    var ssd:any=getLocalJSON('grw_login');
    this.logGender=ssd.gender;
    var mm:any =localStorage.getItem('grw_freevideo');
    if(mm==0 ){
      this.freeshowhide=true;
    }
    var self=this;
    var ss:any = getLocalJSON("grw_upload_Data"); 
    this.post_type= ss.post_type;
    this.post_ctype=ss.post_category;
    this.post_id= ss.record_id;
    if(this.post_ctype==1){
      this.nutritionView=false;
      this.standardview=true; 
      setTimeout(() => {
      $('#pills-standard-tab').trigger('click');
      setTimeout(() => {  $('#pills-standard-tab').addClass(' active');
        self.StandardDetailFormGroup.controls['ms_others'].setValue('N');   
        this.GenderList.filter((el:any)=>{
          if(el.primarySelected ==true){
            el.chcecked=true;
            self.StandardDetailFormGroup.controls['gender'].setValue(el._id);
          } else {
            el.chcecked = false;
          } 
        })}, 100);
      if(this.post_type==1){
        setTimeout(() => {  $('#pills-video-tab').addClass(' active'); }, 300);
      } else if(this.post_type==2){
        setTimeout(() => {  $('#pills-image-tab').addClass(' active'); }, 300);
      } else {
        setTimeout(() => { $('#pills-document-tab').addClass('active'); }, 300);
      }
    }, 200);
    } else { 
      this.standardview=false; 
      this.nutritionView=true; 
      setTimeout(() => {
        $('#pills-nutrition-tab').trigger('click');
        setTimeout(() => {  $('#pills-nutrition-tab').addClass(' active'); }, 100);  
        if(this.post_type==1){
          setTimeout(() => {  $('#pills-video-tab').addClass(' active'); }, 200);
        } else if(this.post_type==2){
          setTimeout(() => {  $('#pills-image-tab').addClass(' active'); }, 200);
        } else {
          setTimeout(() => { $('#pills-document-tab').addClass('active'); }, 200);
        }
      }, 200);      
    }
    this.getAlbumDetail();  
    this.getAllMasterData();
   }

   ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      limitSelection: 2,
    };
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // if(value.length >16){
    //   this.service.dangerAlert('Tags maximum limit is 16 charater');
    //   return;
    // }
    if (value) {
      this.fruits.push({name: value});
    }
    event.chipInput!.clear();
  }

  remove(fruit: any): void {
    const index = this.fruits.indexOf(fruit);
    if (index >= 0) {
      this.fruits.splice(index, 1);
      this.announcer.announce(`Removed ${fruit}`);
    }
  }

  edit(fruit: any, event: any) {
    const value = event.value.trim();
    if (!value) {
      this.remove(fruit);
      return;
    }
    const index = this.fruits.indexOf(fruit);
    if (index >= 0) {
      this.fruits[index].name = value;
    }
  }

  getAllMasterData(){  
    var self=this,ss:any=[],dd:any=[];
    const url = "/common-contents"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        this.allmasterData=response.data;
    this.allmasterData.type.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;
    });
    ss.push(dd);
    this.allmasterData.type =ss;
    ss=[],dd=[];
    this.allmasterData.demographic.filter((el:any)=>{
      el.chcecked = false;
    });
    this.allmasterData.suitability.filter((el:any)=>{
      el.chcecked = false;
    });
    this.allmasterData.location.filter((el:any)=>{
      el.chcecked = false;
    });
    this.allmasterData.medical.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;
    });
    ss.push(dd);
    this.allmasterData.medical =ss;
    ss=[],dd=[];
    this.allmasterData.sub_category.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;
    });
    ss.push(dd);
    this.allmasterData.sub_category =ss;
    ss=[],dd=[];
    this.allmasterData.diet.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;
    })
    ss.push(dd);
    this.allmasterData.diet =ss;
    ss=[],dd=[];
    this.allmasterData.levels.filter((el:any)=>{
      el.chcecked = false;
    })
    this.allmasterData.cooking_times.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;
    })
    ss.push(dd);
    this.allmasterData.cooking_times =ss;
    ss=[],dd=[];
    this.allmasterData.female_cycle.filter((el:any)=>{
      el.chcecked = false;
    })
    // this.allmasterData.genders.filter((el:any)=>{
    //   // if(el._id ==self.logGender){
    //   //   if(el.is_cycle==true){
    //   //     self.cycleChcek=true;
    //   //   } else {
    //   //     self.cycleChcek=false;
    //   //   }
    //   // }
    //   if(el.name!='Other' && el.name!='other'){
    //     ss.push(el);
    //   } else {
    //     dd=el;
    //   }
    //   el.chcecked = false;
    // })
    // ss.push(dd);
    // this.allmasterData.genders =ss;
    ss=[],dd=[];
        this.LevelLIst = this.allmasterData.levels;
        this.GenderList = this.allmasterData.genders;
        this.CycleList = this.allmasterData.female_cycle;
        this.contentpillerList = this.allmasterData.content_pillars;         
        this.TypeList = this.allmasterData.type;
        this.suitabilityList = this.allmasterData.suitability;
        this.medicalList = this.allmasterData.medical;
        this.areasList = this.allmasterData.location;
        this.cookingList = this.allmasterData.cooking_times; 
        this.dietList = this.allmasterData.diet; 
        this.preprationList = this.allmasterData.preparation_times; 
        this.primaryList = this.allmasterData.primary_category; 
        this.subprimaryList = this.allmasterData.sub_category; 
        this.dimendionList = this.allmasterData.dimension;
        this.demographicList =this.allmasterData.demographic;
      }
    }), (error) => { this.loading =false; });
  }

  Onsavesubmit(type:any){
    this.loading=true;
    this.submitted = true;   
    var url="/wizard-single-post";
    var detail:any={};
    let userdetail :any={};
    var count =0 ,count1=0 ,count2=0,count3=0;   
    if(this.standardview){
      userdetail = this.StandardDetailFormGroup;
      userdetail.medical = '';  
      userdetail.equip=[];
      userdetail.sets=[];
      userdetail.reps=[];
      userdetail.steps = [];    
      userdetail.demo='',
      
      this.medicalList.filter((el:any)=>{
        if(el.chcecked == true){
          if(el.childContent == true){
            userdetail.controls["m_others"].setValidators([Validators.required]);
            userdetail.controls["m_others"].updateValueAndValidity();
            }
            if(el.subchildContent  == true){
              userdetail.controls["ms_others"].setValidators([Validators.required]);
              userdetail.controls["ms_others"].updateValueAndValidity();
            }
          if(count == 0){
            userdetail.medical = el._id ;
          } else {
            userdetail.medical = el._id +',' + userdetail.medical;
          } 
          count=count+1;          
        }        
      });
      this.medicalList.filter((el:any)=>{
        if(el.chcecked == false){
          if(el.childContent == true){
            userdetail.controls["m_others"].clearValidators();
            userdetail.controls["m_others"].updateValueAndValidity();
            userdetail.controls["m_others"].setValue('');
            }
        }        
      });
      if (this.EquipmentArray.length !=0)  {
        this.EquipmentArray.filter(function (el:any){
          if(el.equipment!= '' && el.sets== '' && el.reps == ''){
            count1 = 1;
          }
          if(el.equipment!= '' && el.sets!= '' && el.reps != ''){
            userdetail.equip.push(el.equipment);
            userdetail.sets.push(el.sets);
            userdetail.reps.push(el.reps);
          }
        })
              
      } 
      this.stepArray.filter((el:any)=>{
        if(el.text != ''){
        userdetail.steps.push(el.text) ;
        }
        // if(el.text != ''){
        //   if(userdetail.steps==''){
        //     userdetail.steps=el.text ;
        //   } else {
        //     userdetail.steps=el.text +','+userdetail.steps;
        //   }
        // }
      });    
      if(this.post_type ==2){
        userdetail.controls["hours"].setValidators([Validators.required  ,Validators.min(0),Validators.max(23)]);
        userdetail.controls["hours"].updateValueAndValidity();
        userdetail.controls["minute"].setValidators([Validators.required ,Validators.min(0),Validators.max(59)]);
        userdetail.controls["minute"].updateValueAndValidity();
        userdetail.controls["second"].setValidators([Validators.required ,Validators.min(0),Validators.max(59)]);
        userdetail.controls["second"].updateValueAndValidity();
      }
      if(this.otherSelection !=''){
        userdetail.controls["others"].setValidators([Validators.required]);
        userdetail.controls["others"].updateValueAndValidity();
      } else {
        userdetail.controls["others"].clearValidators();
        userdetail.controls["others"].updateValueAndValidity();
        userdetail.controls["others"].setValue('');
      }
      // if(this.cycleChcek){
      //   userdetail.controls["cycle"].setValidators([Validators.required]);
      //   userdetail.controls["cycle"].updateValueAndValidity();
      // }
      detail={  
        'post_id':this.post_id,      
        'description':userdetail.value.description,
        'levels':userdetail.value.level,
        'type':this.Typename,
        'type_other':userdetail.value.others,
        'gender':userdetail.value.gender,
        'female_cycle':userdetail.value.cycle,
        'content_pillar':userdetail.value.contentpiller,
        'balance':userdetail.value.balance,
        'strength':userdetail.value.strength,
        'flexibility':userdetail.value.flexibility,
        'endurance':userdetail.value.endurance,
        'focus':userdetail.value.focus,        
        'medical_condition':userdetail.medical,
        'medical_other':userdetail.value.m_others,
        'medical_subtitle':userdetail.value.ms_others,
        // 'demographic':userdetail.value.demographic,
        'status':type
      }  
      if(userdetail.steps.length ==0 && this.post_type !=1){
        // this.service.dangerAlert('Instructions are mandatory.');
        // this.loading=false;
        // return
      } else{
        detail.steps=userdetail.steps;
      } 
      if(this.EquipmentArray[0].equip != ''){
        detail.equipment=userdetail.equip;
        detail.sets=userdetail.sets;
        detail.reps=userdetail.reps;
      }   
      if(this.post_type !=1){
        detail.doc_time=userdetail.value.hours +':' + userdetail.value.minute +':'+userdetail.value.second;
      } 
    } else {
      userdetail = this.NutritionDetailFormGroup;   
      userdetail.diets = '';
      userdetail.steps = [];   
      userdetail.tags = '';   
      if(this.s_otherSelection !=''){
        userdetail.controls["s_others"].setValidators([Validators.required]);
        userdetail.controls["s_others"].updateValueAndValidity();
      }
      this.dietList.filter((el:any)=>{
        if(el.chcecked == true){
          if(el.childContent == true){
            userdetail.controls["d_others"].setValidators([Validators.required]);
            userdetail.controls["d_others"].updateValueAndValidity();      
            }
          if(count2 == 0){
            userdetail.diets = el._id ;
          } else {
            userdetail.diets = el._id +',' + userdetail.diets;
          } 
          count2=count2+1;          
        }         
      });
      this.dietList.filter((el:any)=>{
        if(el.chcecked == false){
          if(el.childContent == true){
           userdetail.controls["d_others"].clearValidators();
           userdetail.controls["d_others"].updateValueAndValidity();     
           userdetail.controls["d_others"].setValue(''); 
          }
        }         
      });

      // if(this.subprimaryname == '' && userdetail.value.primarycategory==''){
      //   this.service.dangerAlert('Please Select Primary Category Or Sub Category Option');
      //   this.loading=false;
      //   return
      // }
      if(this.fruits.length !=0){
        this.fruits.filter((el:any)=>{
          if(count1==0){
            userdetail.tags = el.name;
          } else {
            userdetail.tags = el.name +','+userdetail.tags;
          }
          count1=count1+1;
        })
      }   

      this.stepArray.filter((el:any)=>{
        if(el.text != ''){
        userdetail.steps.push(el.text) ;
        }
        // if(el.text != ''){
        //   if(userdetail.steps==''){
        //     userdetail.steps=el.text ;
        //   } else {
        //     userdetail.steps=el.text +','+userdetail.steps;
        //   }
        // }
      }); 
      detail={        
        'description':userdetail.value.description,
        'diet':userdetail.diets,
        'diet_other':userdetail.value.d_others,
        'post_id':this.post_id,
        'pre_time':userdetail.value.prepTime,
        'cooking_time':userdetail.value.cookingTime,
        'totalTime':userdetail.value.totalTime,
        'primary_category':userdetail.value.primarycategory,
        'sub_category':this.subprimaryname,
        'subcategory_other':userdetail.value.s_others,
        'calories':userdetail.value.balance,
        // 'demographic':userdetail.value.demographic,
        'ingredients':userdetail.tags,
        'status':type
      }    
      if(userdetail.steps.length ==0 && this.post_type !=1){
        // this.service.dangerAlert('Instructions are mandatory.');
        // this.loading=false;
        // return
      } else{
        detail.steps=userdetail.steps;
      }   
    }
    if(this.post_type !=2){
      detail.dimension=this.dimendionList[0]._id; 
    }
    this.demographicList.filter((el:any)=>{
      if(el.chcecked == true){
        if(count3 == 0){
          userdetail.demo = el._id ;
        } else {
          userdetail.demo = el._id +',' + userdetail.demo;
        } 
        count3=count3+1;          
      }        
    });

    if(count3==0){
            userdetail.controls["demographic"].setValue('');

    //   this.service.dangerAlert('Demographics are mandatory.');
    //   this.loading=false;
    //   return
    } else{
      detail.demographic=userdetail.demo;
    } 
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1){           
          this.submitted = false;
          this.loading=false;
          this.router.navigate(['/singles']);
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
      });
    
  }

  Onsubmit(type:any){
    this.loading=true;
    this.submitted = true;   
    var url="/wizard-single-post";
    var detail:any={};
    let userdetail :any={};
    userdetail.demo='';
    var count =0 ,count1=0 ,count2=0,count3=0;   
    if(this.standardview){
      userdetail = this.StandardDetailFormGroup;
      userdetail.medical = '';  
      userdetail.equip=[];
      userdetail.sets=[];
      userdetail.reps=[];
      userdetail.steps = [];    
      
      this.medicalList.filter((el:any)=>{
        if(el.chcecked == true){
          if(el.childContent == true){
            userdetail.controls["m_others"].setValidators([Validators.required]);
            userdetail.controls["m_others"].updateValueAndValidity();
            }
            if(el.subchildContent  == true){
              userdetail.controls["ms_others"].setValidators([Validators.required]);
              userdetail.controls["ms_others"].updateValueAndValidity();
            }
          if(count == 0){
            userdetail.medical = el._id ;
          } else {
            userdetail.medical = el._id +',' + userdetail.medical;
          } 
          count=count+1;          
        }        
      });
      this.medicalList.filter((el:any)=>{
        if(el.chcecked == false){
          if(el.childContent == true){
            userdetail.controls["m_others"].clearValidators();
            userdetail.controls["m_others"].updateValueAndValidity();
            userdetail.controls["m_others"].setValue('');
            }
        }        
      });
      if (this.EquipmentArray.length !=0)  {
        this.EquipmentArray.filter(function (el:any){
          if(el.equipment!= '' && el.sets== '' && el.reps == ''){
            count1 = 1;
          }
          if(el.equipment!= '' && el.sets!= ''  && el.reps != '' ){
            userdetail.equip.push(el.equipment);
            userdetail.sets.push(el.sets);
            userdetail.reps.push(el.reps);
          }
        })
              
      } 
      this.stepArray.filter((el:any)=>{
        if(el.text != ''){
        userdetail.steps.push(el.text) ;
        }
        // if(el.text != ''){
        //   if(userdetail.steps==''){
        //     userdetail.steps=el.text ;
        //   } else {
        //     userdetail.steps=el.text +','+userdetail.steps;
        //   }
        // }
      });    
      if(this.post_type ==2){
        userdetail.controls["hours"].setValidators([Validators.required  ,Validators.min(0),Validators.max(23)]);
        userdetail.controls["hours"].updateValueAndValidity();
        userdetail.controls["minute"].setValidators([Validators.required ,Validators.min(0),Validators.max(59)]);
        userdetail.controls["minute"].updateValueAndValidity();
        userdetail.controls["second"].setValidators([Validators.required ,Validators.min(0),Validators.max(59)]);
        userdetail.controls["second"].updateValueAndValidity();
      }
      if(this.otherSelection !=''){
        userdetail.controls["others"].setValidators([Validators.required]);
        userdetail.controls["others"].updateValueAndValidity();
      } else {
        userdetail.controls["others"].clearValidators();
        userdetail.controls["others"].updateValueAndValidity();
        userdetail.controls["others"].setValue('');
      }
      // if(this.cycleChcek){
      //   userdetail.controls["cycle"].setValidators([Validators.required]);
      //   userdetail.controls["cycle"].updateValueAndValidity();
      // }
      detail={  
        'post_id':this.post_id,      
        'description':userdetail.value.description,
        'levels':userdetail.value.level,
        'type':this.Typename,
        'type_other':userdetail.value.others,
        'gender':userdetail.value.gender,
        'female_cycle':userdetail.value.cycle,
        'content_pillar':userdetail.value.contentpiller,
        'balance':userdetail.value.balance,
        'strength':userdetail.value.strength,
        'flexibility':userdetail.value.flexibility,
        'endurance':userdetail.value.endurance,
        'focus':userdetail.value.focus,        
        'medical_condition':userdetail.medical,
        'medical_other':userdetail.value.m_others,
        'medical_subtitle':userdetail.value.ms_others,
        // 'demographic':userdetail.value.demographic,
        'status':type
      }  
      if(userdetail.steps.length ==0 && this.post_type !=1){
        this.service.dangerAlert('Instructions are mandatory.');
        this.loading=false;
        return
      } else{
        detail.steps=userdetail.steps;
      } 
      if(this.EquipmentArray[0].equip != ''){
        detail.equipment=userdetail.equip;
        detail.sets=userdetail.sets;
        detail.reps=userdetail.reps;
      }   
      if(this.post_type !=1){
        detail.doc_time=userdetail.value.hours +':' + userdetail.value.minute +':'+userdetail.value.second;
      } 
    } else {
      userdetail = this.NutritionDetailFormGroup;   
      userdetail.diets = '';
      userdetail.steps = [];   
      userdetail.tags = '';   
      if(this.s_otherSelection !=''){
        userdetail.controls["s_others"].setValidators([Validators.required]);
        userdetail.controls["s_others"].updateValueAndValidity();
      }
      this.dietList.filter((el:any)=>{
        if(el.chcecked == true){
          if(el.childContent == true){
            userdetail.controls["d_others"].setValidators([Validators.required]);
            userdetail.controls["d_others"].updateValueAndValidity();      
            }
          if(count2 == 0){
            userdetail.diets = el._id ;
          } else {
            userdetail.diets = el._id +',' + userdetail.diets;
          } 
          count2=count2+1;          
        }         
      });
      this.dietList.filter((el:any)=>{
        if(el.chcecked == false){
          if(el.childContent == true){
           userdetail.controls["d_others"].clearValidators();
           userdetail.controls["d_others"].updateValueAndValidity();     
           userdetail.controls["d_others"].setValue(''); 
          }
        }         
      });

      // if(this.subprimaryname == '' && userdetail.value.primarycategory==''){
      //   this.service.dangerAlert('Please Select Primary Category Or Sub Category Option');
      //   this.loading=false;
      //   return
      // }
      if(this.fruits.length !=0){
        this.fruits.filter((el:any)=>{
          if(count1==0){
            userdetail.tags = el.name;
          } else {
            userdetail.tags = el.name +','+userdetail.tags;
          }
          count1=count1+1;
        })
      }   

      this.stepArray.filter((el:any)=>{
        if(el.text != ''){
        userdetail.steps.push(el.text) ;
        }
        // if(el.text != ''){
        //   if(userdetail.steps==''){
        //     userdetail.steps=el.text ;
        //   } else {
        //     userdetail.steps=el.text +','+userdetail.steps;
        //   }
        // }
      }); 
      detail={        
        'description':userdetail.value.description,
        // 'diet':userdetail.diets,
        'diet_other':userdetail.value.d_others,
        'post_id':this.post_id,
        'pre_time':userdetail.value.prepTime,
        'cooking_time':userdetail.value.cookingTime,
        'total_time':userdetail.value.totalTime,
        'primary_category':userdetail.value.primarycategory,
        'sub_category':this.subprimaryname,
        'subcategory_other':userdetail.value.s_others,
        'calories':userdetail.value.balance,
        // 'demographic':userdetail.value.demographic,
        'ingredients':userdetail.tags,
        'status':type
      }    
      if(userdetail.steps.length ==0 && this.post_type !=1){
        this.service.dangerAlert('Instructions are mandatory.');
        this.loading=false;
        return
      } else{
        detail.steps=userdetail.steps;
      }   
      if(count2==0){
      userdetail.controls["diet"].setValue('');
    } else{
      detail.diet=userdetail.diets;
    } 
    }
    if(this.post_type !=2){
      detail.dimension=this.dimendionList[0]._id; 
    }
    this.demographicList.filter((el:any)=>{
      if(el.chcecked == true){
        if(count3 == 0){
          userdetail.demo = el._id ;
        } else {
          userdetail.demo = el._id +',' + userdetail.demo;
        } 
        count3=count3+1;          
      }        
    });


    if(count3==0){
      userdetail.controls["demographic"].setValue('');

    //   this.service.dangerAlert('Demographics are mandatory.');
    //   this.loading=false;
    //   return
    } else{
      detail.demographic=userdetail.demo;
    } 

    if(userdetail.valid){           
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1){           
          this.submitted = false;
          this.loading=false;
          this.router.navigate(['/singles']);
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
      });
    } else{
      this.loading = false
      const invalidControls: string[] = [];
      Object.keys(userdetail.controls).forEach((controlName) => {
        const control = userdetail.get(controlName);
        if (control && control.invalid) {
          invalidControls.push(controlName);
        }
      });
      if(invalidControls.length >1){
        this.service.dangerAlert('Please complete mandatory sections.');
      } else {
        var ss='';
        if(invalidControls[0]=='contentpiller'){
          ss='Content piller';
        }  else if(invalidControls[0]=='diet'){
          ss='Diet';
        }  else if(invalidControls[0]=='demographic'){
          ss='Demographic';
        }
        else if(invalidControls[0]=='totalTime'){
          ss='Total Time';
        }
        else if(invalidControls[0]=='prepTime'){
          ss='Prep Time';
        }
        else if(invalidControls[0]=='cookingTime'){
          ss='Cooking Time';
        }
        else if(invalidControls[0]=='balance'){
          ss='Calories';
        } else if(invalidControls[0]=='sprimary'){
          ss='Type';
        }
       else if(invalidControls[0]=='d_others'){
        ss='Diet Other';
      }
      else if(invalidControls[0]=='keywords'){
        ss='Tags';
      }
      else if(invalidControls[0]=='m_others'){
        ss='Medical Other';
      }
      else if(invalidControls[0]=='others'){
        ss='Type Other';
      }
      else if(invalidControls[0]=='level'){
        ss='Level';
      } else if(invalidControls[0]=='description'){
        ss='Description';
      } else if(invalidControls[0]=='albumName'){
        ss='Title';
      } else if(invalidControls[0]=='gender'){
        ss='Gender';
      } else {
        ss=invalidControls[0];
      } 
        this.service.dangerAlert(ss +' is required.');
      }
      userdetail.markAllAsTouched();
      this.scrollToFirstInvalidControl();  
    } 
  }

  onTagsChanged(event:any){
  }

  getsetData(event:any,item:any){
      if(event.target.checked){
        this.stepArray[item-1].textdisabled=false;
      } else {       
        this.stepArray[item-1].text='';
        this.stepArray[item-1].textdisabled=true;
      }
  }

  getCheckboxexData(event:any,type:any){
    var subcatText: any='',self=this,count=0;
    if(type==1){
      this.medicalList.filter((el:any)=>{
        if(event.target.checked){
          if(event.target.value ==el._id && el.childContent==true){
            self.m_otherSelection =el._id;
          }
          if(event.target.value ==el._id && el.subchildContent==true){
            self.ms_otherSelection =el._id;
          }
          if(el._id == event.target.value){
            el.chcecked = true;
          }
        } else {
          if(event.target.value ==el._id && el.childContent==true){
            self.m_otherSelection ='';
          }
          if(event.target.value ==el._id && el.subchildContent==true){
            self.ms_otherSelection ='';
          }
          if(el._id == event.target.value){
            el.chcecked = false;
          }
        }        
      })
    } else if(type==2){
      this.suitabilityList.filter((el:any)=>{
        if(event.target.checked){  
          if(event.target.value == el._id ){
            if(el.multiSelect==true){
              self.suitabilityList.filter((ell:any)=>{
                ell.chcecked = true;
              })
              return;            
            } else{
              el.chcecked = true;
              return;
            }
          }    
        } else {   
          if(event.target.value == el._id ){ 
            self.suitabilityList.filter((el:any)=>{
              if(el.multiSelect==true && el.chcecked == true){
                self.suitabilityList.filter((ell:any)=>{
                  ell.chcecked = false;
                })
                return;
              } else{
                if(event.target.value == el._id ){
                  el.chcecked = false;
                }
                return;
              }
            })  
            return;         
          }
        }       
      })
    } else if(type==3){
      if (this.subprimarySelected.length != 0) {
        this.subprimarySelected.filter(function (el: any) {
          if (subcatText) {
            subcatText = el._id + " , " + subcatText;
          } else {
            subcatText = el._id;
          }       
          self.subprimaryList.filter((ell:any)=>{
            if(ell._id==el._id && ell.childContent==true){
              count =1;           
            }
          })
          if(count ==1){
            self.s_otherSelection =el._id;
          } else {
            self.s_otherSelection ='';
          }
        });
        
        if(subcatText !=''){
          this.subprimaryname= subcatText;
        }
      }    
    } else if(type==4){
      this.dietList.filter((el:any)=>{
        if(event.target.checked){
          if(event.target.value ==el._id && el.childContent==true){
            self.d_otherSelection =el._id;
          }
          if(el._id == event.target.value){
            el.chcecked = true;
          }
        } else {
          if(event.target.value ==el._id && el.childContent==true){
            self.d_otherSelection ='';
          }
          if(el._id == event.target.value){
            el.chcecked = false;
          }
        }        
      })
    } else if(type==5)  {
      if (this.TypeSelected.length != 0) {
        this.TypeSelected.filter(function (el: any) {
          if (subcatText) {
            subcatText = el._id + " , " + subcatText;
          } else {
            subcatText = el._id;
          }       
          self.TypeList.filter((ell:any)=>{
            if(ell._id==el._id && ell.childContent==true){
              count =1;           
            }
          })
          if(count ==1){
            self.otherSelection =el._id;
          } else {
            self.otherSelection ='';
          }
        });
        
        if(subcatText !=''){
          this.Typename= subcatText;
        }
      }
      // this.TypeList.filter((el:any)=>{
      //   if(event.target.checked){
      //     if(event.target.value ==el._id && el.childContent==true){
      //       self.otherSelection =el._id;
      //     }
      //     if(el._id == event.target.value){
      //       el.chcecked = true;
      //     }
      //   } else {
      //     if(event.target.value ==el._id && el.childContent==true){
      //       self.otherSelection ='';
      //     }
      //     if(el._id == event.target.value){
      //       el.chcecked = false;
      //     }
      //   }        
      // })
    } else if(type==6){
      this.LevelLIst.filter((el:any)=>{
        if(event.target.checked){  
          if(event.target.value == el._id ){
            if(el.multiSelect==true){
              self.LevelLIst.filter((ell:any)=>{
                ell.chcecked = true;
              })
              return;            
            } else{
              el.chcecked = true;
              return;
            }
          }    
          
        } else {   
          if(event.target.value == el._id ){ 
            self.LevelLIst.filter((el:any)=>{
              if(el.multiSelect==true && el.chcecked == true){
                self.LevelLIst.filter((ell:any)=>{
                  ell.chcecked = false;
                })
                return;
              } else{
                if(event.target.value == el._id ){
                  el.chcecked = false;
                }
                return;
              }
            })  
            return;         
            }
        }       
      })
    } else if(type==7){
      this.cookingList.filter((el:any)=>{
          if(event.target.id ==el._id && el.childContent==true){
            self.c_otherSelection =el._id;
          } 
          if(event.target.id ==el._id && el.childContent==false){
            self.c_otherSelection ='';
          }                 
      })  
    } else  if(type==9){
      this.demographicList.filter((el:any)=>{
        if(event.target.checked){
          if(el._id == event.target.value){
            el.chcecked = true;
          }
        } else {
          if(el._id == event.target.value){
            el.chcecked = false;
          }
        }        
      })
    } else {
        this.freechcek =event.target.checked;
    }
  }
  
  getAlbumDetail(){
    var url="/album-list";
    var detail={
      "page": 1,
      "status": '',
      "is_paginate": false,
      "search": "",
    };
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1) {        
        this.albumList= response.data;
      } else {
        this.albumList=[];
      }
    }), (error) => { this.loading =false; });
  }

private scrollToFirstInvalidControl() {
  const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
    "form .ng-invalid"
  );
  // firstInvalidControl.focus(); //without smooth behavior
  window.scroll({
    top: this.getTopOffset(firstInvalidControl),
    left: 0,
    behavior: "smooth"
  });
}

private getTopOffset(controlEl: HTMLElement): number {
  const labelOffset = 50;
  return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
}

viewReset(){
  this.submitted=false;
  this.imgURL='';
  this.videoName='';
  this.videoSize='';
  this.videoUrl='';
  this.selectedFile='';
  this.selectedVidoe='';
  this.sliderArray=[{id:1,name:'Balance',text:'balance', value:1},
  {id:2,name:'Flexibility',text:'flexibility', value:1},
  {id:3,name:'Focus',text:'focus', value:1},
  {id:4,name:'Strength',text:'strength', value:1},
  {id:5,name:'Endurance',text:'endurance', value:1},
  ];  
  this.sliderArray1=[{id:1,name:'Balance',text:'balance', value:1},
  {id:2,name:'Flexibility',text:'flexibility', value:1},
  {id:3,name:'Focus',text:'focus', value:1},
  {id:4,name:'Strength',text:'strength', value:1},
  {id:5,name:'Endurance',text:'endurance', value:1},
  ]; 
  this.sliderArray2=[{id:1,name:'Balance',text:'balance', value:1},
  {id:2,name:'Flexibility',text:'flexibility', value:1},
  {id:3,name:'Focus',text:'focus', value:1},
  {id:4,name:'Strength',text:'strength', value:1},
  {id:5,name:'Endurance',text:'endurance', value:1},
  ]; 
  this.stepArray=[{id:1,text:'',textdisabled:true, checkdisabled:false},
  ];
  this.EquipmentArray=[{id: 1,equipment: '',sets: '',reps:''}];

  this.TypeList.filter((el:any)=>{
    el.chcecked = false;
  });
  this.suitabilityList.filter((el:any)=>{
    el.chcecked = false;
  });
  this.medicalList.filter((el:any)=>{
    el.chcecked = false;
  });
  this.subprimaryList.filter((el:any)=>{
    el.chcecked = false;
  });
  this.dietList.filter((el:any)=>{
    el.chcecked = false;
  })
  this.LevelLIst.filter((el:any)=>{
    el.chcecked = false;
  })
  this.fruits=[];
  this.chceckall=false;
}

wordCounter(){
  var self=this;
  var value = $('#AboutText').val();
  if (value.length == 0) {
    return;
  }
  var regex = /\s+/gi;
  var wordCount = value.trim().replace(regex, ' ').split(' ').length;
  self.mesage = wordCount;
}

Addmore(type:any){
  if(type ==1){
    if(this.EquipmentArray[this.EquipmentArray.length-1].equipment!='' && this.EquipmentArray[this.EquipmentArray.length-1].sets!=''  && this.EquipmentArray[this.EquipmentArray.length-1].sets!=null  && this.EquipmentArray[this.EquipmentArray.length-1].sets <=999 && this.EquipmentArray[this.EquipmentArray.length-1].reps!='' && this.EquipmentArray[this.EquipmentArray.length-1].reps!=null && this.EquipmentArray[this.EquipmentArray.length-1].reps<=999){
      if(this.EquipmentArray.length <= 10){
        this.EquipmentArray.push({
          id: this.EquipmentArray.length + 1,
          equipment: '',
          sets: '',
          reps:'',
        });
      }
    }
  } else {
    var size:any=''
    if(type==2){
      size=10;
    } else {
      size=5;
    }
    if(this.stepArray[this.stepArray.length-1].text!='' ){
      if(this.stepArray.length <= size){
        this.stepArray.push({
          id: this.stepArray.length + 1,
          text:'',
          textdisabled:true,
          checkdisabled:false
        });
      }
    }
  }

}

removeItem(item:any,type:any){  
    var arr:any = [] ;  var count=1;
    if(type == 1){
      this.EquipmentArray.filter((el:any)=>{
        if(el.id != item){
          el.id= count;
          arr.push(el);
          count=count+1;
        }
      })
      this.EquipmentArray = arr;
    } else {
      this.stepArray.filter((el:any)=>{
        if(el.id != item){
          el.id= count;
          arr.push(el);
          count=count+1;
        }
      })
      this.stepArray = arr;
    }
 
}

sliderEvent() { }

onFilterChange(event: any, type: any) { }

getChaecks(event:any,type:any){
  var self=this;
  if(type==1){
    this.GenderList.filter((el:any)=>{
      if(el._id ==self.logGender){
        self.logGendername=el.name;
      }
      if(el._id == event.target.id){
        if(el._id ==self.logGender){
          if(el.is_cycle==true){
            self.cycleChcek=true;
          } else {
            self.cycleChcek=false;
          }
        }  else {
          if(self.logGendername =='female' ||  self.logGendername =='Female' ||  self.logGendername =='Non-binary' || self.logGendername =='non-binary' ){
            if(el.is_cycle==true){
              self.cycleChcek=true;
            } else {
              self.cycleChcek=false;
            }
          } else {
            self.cycleChcek=false;
          }
        
        }
        el.checked=true;
      } else {
        el.checked=false;
      }
    })
  } else {
    this.CycleList.filter((el:any)=>{
      if(el._id == event.target.id){
        if(el.chcecked==true){
          $("#"+event.target.id).prop("checked", false); 
          el.chcecked=false;
          self.StandardDetailFormGroup.controls['cycle'].setValue('');
        } else {
          $("#"+event.target.id).prop("checked", true); 
          el.chcecked=true;
        }
       
      } else {
        el.checked=false;
      }

    })
  }

}

}
